<template>
  <div v-if="!loading" class="container">
    <div class="footer__block">
      <div class="fiter__block flex">
        <img
          class="logo"
          src="https://spa-bitrix.ru/masthev_selections/img/logo.png"
          alt="logo"
        />
      </div>
    </div>
    <div
      class="card__block flex"
      v-for="(item, index) in items"
      :key="index"
    >
      <card
        class="card"
        :item="item"
        @click="item.showDialog = !item.showDialog"
        v-model="item.selected"
      />
      <Transition name="fade" class="modal__block">
        <div class="modal" v-if="item.showDialog">
          <objectCard :item="item" v-model="item.showDialog" />
        </div>
      </Transition>
    </div>
  </div>
  <div v-else class="container progress-block">
    <v-progress-circular
      indeterminate
      color="red"
      :size="118"
    ></v-progress-circular>
  </div>
</template>

<script>
import card from "@/components/card-selection.vue";
import objectCard from "@/components/object-card.vue";
export default {
  name: "selection-vue",
  props: {
    url: String,
    items: Array,
  },
  components: { card, objectCard },
  data() {
    return {
//
    };
  },
  async mounted() {
    const onResizewidth = () => (this.width = window.innerWidth);
    onResizewidth();
    window.addEventListener("resize", onResizewidth);
    const onResizeheight = () => (this.height = window.innerHeight);
    onResizeheight();
    window.addEventListener("resize", onResizeheight);
  },
};
</script>

<style scoped></style>
